/* istanbul ignore file REMOVE THIS WHEN I18NPLACEHOLDERS ARE REMOVED */
import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/startAPetition/start-a-petition.yml';

import { StartAPetition as StartAPetitionBase } from './entrypoint';

export const StartAPetition = withI18nPlaceholders(I18N_PLACEHOLDERS, StartAPetitionBase);
